import React, { useMemo, useState } from 'react'
import Divider from '../../../../components/atoms/Divider'
import PageHeading from '../common/PageHeading'
import PageLayout from '../common/PageLayout'
import Loading from '../../../../components/molecules/Loading'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import NoResults from '../common/NoResults'
import SydLinkButton from '../../../../components/commonDesign/LinkButton'
import ClientFocusSelector from '../common/ClientFocusSelector'
import { useListMeetings } from '../../../../api/meetings'
import MeetingCard from './MeetingCard'

const TERMINAL = ['completed', 'failed', 'cancelled']

function MeetingsHome () {
  const [clientFocus, setClientFocus] = useState(null)
  const filters = useMemo(() => ({
    clientId: clientFocus?.subjectIdentifier ?? null
  }), [clientFocus])

  const { data: meetings, isLoading } = useListMeetings(filters, {
    refetchInterval: (data) => {
      if (!Array.isArray(data)) return false
      return data.some(m => !TERMINAL.includes(m.status)) ? 15000 : false
    }
  })

  const meetingList = useMemo(() => Array.isArray(meetings) ? meetings : [], [meetings])

  if (isLoading) {
    return (
      <PageLayout variant='constrained'>
        <Loading />
      </PageLayout>
    )
  }

  return (
    <PageLayout variant='constrained'>
      <PageHeading title='Meetings'>
        <FlexRow className='gap-sm'>
          <ClientFocusSelector value={clientFocus} onChange={setClientFocus} />
          <SydLinkButton variant='primary' size='sm' to={{ pathname: '/denali-ai/meetings/new', state: { clientFocus } }}>
            New Meeting
          </SydLinkButton>
        </FlexRow>
      </PageHeading>
      <Divider />
      {meetingList.length === 0 ? (
        <NoResults message={clientFocus ? 'No meetings for this client' : 'No meetings yet'} />
      ) : (
        <FadeIn>
          <FlexColumn className='gap-sm'>
            {meetingList.map(meeting => (
              <MeetingCard key={meeting.meetingId} meeting={meeting} />
            ))}
          </FlexColumn>
        </FadeIn>
      )}
    </PageLayout>
  )
}

export default MeetingsHome
